import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

export interface CheckEmailAuthCodeRequest {
  code: number;
}

export const checkEmailAuthCode = ({ code }: CheckEmailAuthCodeRequest) => {
  return api.get<ApiResponse>('/auth/email', {
    params: {
      code,
    },
  });
};

const useCheckEmailAuthCode = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse>,
    TError,
    CheckEmailAuthCodeRequest,
    ['checkEmail']
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse>,
  TError,
  CheckEmailAuthCodeRequest
> => {
  return useMutation(checkEmailAuthCode, {
    ...options,
  });
};

export default useCheckEmailAuthCode;
